<app-navbar-style-two></app-navbar-style-two>

<section class="product-details-page" *ngIf="product">

  <!-- ═══════════════════════════════
       TOP: GALLERY + DETAILS
  ═══════════════════════════════ -->
  <div class="product-wrapper container">

    <!-- ── GALLERY ── -->
    <div class="gallery-section">

      <div class="main-image-card">

        <!-- Stock badge -->
        <span class="stock-badge"
          [ngClass]="{'in-stock': product.available === 'In Stock', 'out-stock': product.available !== 'In Stock'}">
          {{ product.available }}
        </span>

        <!-- Wishlist + Share -->
        <div class="image-actions">
          <button class="action-btn" (click)="toggleWishlist()" aria-label="Add to wishlist">
            <i class='bx bx-heart'></i>
          </button>
          <button class="action-btn" (click)="shareProduct()" aria-label="Share product">
            <i class='bx bx-share-alt'></i>
          </button>
        </div>

        <!-- Prev / Next nav -->
        <button class="gallery-nav prev" *ngIf="images.length > 1" (click)="previousImage()" aria-label="Previous image">
          <i class='bx bx-chevron-left'></i>
        </button>
        <button class="gallery-nav next" *ngIf="images.length > 1" (click)="nextImage()" aria-label="Next image">
          <i class='bx bx-chevron-right'></i>
        </button>

        <!-- Main image -->
        <div class="main-image">
          <img [src]="selectedImage"
               (error)="imageError($event)"
               [alt]="product.product_name"
               loading="eager">
          <button class="zoom-btn" (click)="openZoomModal()" aria-label="Zoom image">
            <i class='bx bx-search-alt'></i>
          </button>
        </div>

      </div>

      <!-- Thumbnails -->
      <div class="thumbnail-wrapper" *ngIf="images.length">
        <button class="thumb-nav prev" *ngIf="visibleThumbnailStart > 0"
                (click)="previousThumbnails()" aria-label="Previous thumbnails">
          <i class='bx bx-chevron-left'></i>
        </button>

        <div class="thumbnail-list">
          <div class="thumbnail"
               *ngFor="let image of visibleThumbnails"
               [class.active]="selectedImage === image"
               (click)="selectImage(image)"
               role="button"
               [attr.aria-label]="'View image'">
            <img [src]="image" (error)="imageError($event)" loading="lazy">
          </div>
        </div>

        <button class="thumb-nav next"
                *ngIf="visibleThumbnailStart + maxVisibleThumbnails < images.length"
                (click)="nextThumbnails()" aria-label="Next thumbnails">
          <i class='bx bx-chevron-right'></i>
        </button>
      </div>

    </div><!-- /gallery-section -->

    <!-- ── DETAILS ── -->
    <div class="details-section">

      <!-- Brand pill -->
      <span class="brand-name">{{ product.brand_name }}</span>

      <!-- Title -->
      <h1>{{ product.product_name }}</h1>

      <!-- Rating -->
      <div class="product-rating">
        <div class="stars">
          <i class='bx bxs-star' *ngFor="let star of getStars(averageRating)"></i>
        </div>
        <span>{{ reviews.length }} Reviews</span>
      </div>

      <!-- Short description -->
      <div class="description">
        <p>
          {{ product.description | slice:0:150 }}
          <span *ngIf="product.description?.length > 150">...</span>
        </p>
        <button *ngIf="product.description?.length > 150" (click)="goToDescription()">
          Read More
        </button>
      </div>

      <!-- Price -->
      <div class="price-section">
        <span class="offer-price">
          ₹{{ product.product_cost || product.mrp_price }}
        </span>
        <span *ngIf="product.product_cost" class="mrp">₹{{ product.mrp_price }}</span>
        <span *ngIf="product.product_cost" class="discount-badge">
          {{ getDiscountPercentage() }}% OFF
        </span>
      </div>
      <div *ngIf="product.product_cost" class="saving">
        You save ₹{{ getSavingsAmount() }}
      </div>

      <!-- Qty + Cart -->
      <div class="quantity-cart">
        <div class="qty-box">
          <button (click)="decreaseQuantity()" aria-label="Decrease quantity">−</button>
          <span>{{ quantity }}</span>
          <button (click)="increaseQuantity()" aria-label="Increase quantity">+</button>
        </div>
        <button class="cart-btn"
                [disabled]="product.available !== 'In Stock'"
                (click)="addToCart()">
          <i class='bx bx-cart'></i> Add To Cart
        </button>
      </div>

      <!-- Trust highlights -->
      <div class="highlights">
        <div class="highlight-item">
          <i class='bx bx-check-shield'></i>
          <span>Premium Quality</span>
        </div>
        <div class="highlight-item">
          <i class='bx bx-package'></i>
          <span>Safe Packaging</span>
        </div>
        <div class="highlight-item">
          <i class='bx bx-refresh'></i>
          <span>Easy Returns</span>
        </div>
        <div class="highlight-item">
          <i class='bx bx-truck'></i>
          <span>Fast Delivery</span>
        </div>
      </div>

    </div><!-- /details-section -->

  </div><!-- /product-wrapper -->


  <!-- ═══════════════════════════════
       PRODUCT TABS
  ═══════════════════════════════ -->
  <div class="product-tabs">

    <div class="tab-header" role="tablist">
      <button [class.active]="activeTab === 'reviews'"
              (click)="setTab('reviews')" role="tab"
              [attr.aria-selected]="activeTab === 'reviews'">
        Reviews ({{ reviews.length }})
      </button>
      <button [class.active]="activeTab === 'details'"
              (click)="setTab('details')" role="tab"
              [attr.aria-selected]="activeTab === 'details'">
        Product Details
      </button>
      <button [class.active]="activeTab === 'description'"
              (click)="setTab('description')" role="tab"
              [attr.aria-selected]="activeTab === 'description'">
        Description
      </button>
      <button [class.active]="activeTab === 'specifications'"
              (click)="setTab('specifications')" role="tab"
              [attr.aria-selected]="activeTab === 'specifications'">
        Specifications
      </button>
    </div>

    <div class="tab-content">

      <!-- ── REVIEWS ── -->
      <div *ngIf="activeTab === 'reviews'">

        <div class="reviews-grid">
          <div class="review-card" *ngFor="let review of pagedReviews">

            <div class="review-header">
              <div class="review-user">
                <div class="avatar">{{ review.customer_name?.charAt(0) }}</div>
                <div>
                  <h4>{{ review.customer_name }}</h4>
                  <div class="stars">
                    <i class='bx bxs-star' *ngFor="let star of getStars(review.rating)"></i>
                  </div>
                </div>
              </div>
              <div class="review-date">{{ review.created_date }}</div>
            </div>

            <p class="review-text">
              {{ review.review_comment?.length > 50
                 ? (review.review_comment | slice:0:50)
                 : review.review_comment }}
              <ng-container *ngIf="review.review_comment?.length > 50">
                ...
                <button class="read-more-btn" (click)="openReviewModal(review)">Read More</button>
              </ng-container>
            </p>

          </div>
        </div>

        <!-- Review pagination -->
        <div class="pagination" *ngIf="reviewPages.length > 1">
          <button *ngFor="let page of reviewPages"
                  [class.active]="currentReviewPage === page"
                  (click)="changeReviewPage(page)">{{ page }}</button>
        </div>

        <!-- Review form -->
        <div class="review-form">
          <h3>Write a Review</h3>
          <form [formGroup]="reviewForm" (ngSubmit)="submitReview()">
            <div class="rating-selector">
              <i *ngFor="let star of [1,2,3,4,5]"
                 class="bx"
                 [ngClass]="{'bxs-star': reviewForm.get('rating')?.value >= star, 'bx-star': reviewForm.get('rating')?.value < star}"
                 (click)="setRating(star)"></i>
            </div>
            <textarea rows="5" placeholder="Share your thoughts about this product…"
                      formControlName="review_comment"></textarea>
            <button type="submit" class="submit-btn" [disabled]="isSubmitting">
              <ng-container *ngIf="!isSubmitting">
                <i class='bx bx-send'></i> Submit Review
              </ng-container>
              <ng-container *ngIf="isSubmitting">
                <i class='bx bx-loader-alt bx-spin'></i> Submitting…
              </ng-container>
            </button>
          </form>
        </div>

      </div>

      <!-- ── PRODUCT DETAILS ── -->
      <div *ngIf="activeTab === 'details'" class="details-table">
        <div class="detail-row" *ngFor="let item of getProductDetails()">
          <span>{{ item.key }}</span>
          <strong>{{ item.value }}</strong>
        </div>
      </div>

      <!-- ── DESCRIPTION ── -->
      <div *ngIf="activeTab === 'description'" class="description-tab">
        <h2>Product Description</h2>
        <p>{{ product.description }}</p>
      </div>

      <!-- ── SPECIFICATIONS ── -->
      <div *ngIf="activeTab === 'specifications'" class="specifications-grid">
        <div class="spec-card">
          <span>Brand</span>
          <strong>{{ product.brand_name }}</strong>
        </div>
        <div class="spec-card">
          <span>Material</span>
          <strong>{{ product.material || '—' }}</strong>
        </div>
        <div class="spec-card">
          <span>Color</span>
          <strong>{{ product.color || '—' }}</strong>
        </div>
      </div>

    </div><!-- /tab-content -->

  </div><!-- /product-tabs -->


  <!-- ═══════════════════════════════
       RELATED PRODUCTS
  ═══════════════════════════════ -->
  <div class="related-products" *ngIf="relatedProducts.length">

    <div class="section-title">
      <span class="section-tag">You May Also Like</span>
      <h2>Related Toys</h2>
    </div>

    <div class="products-grid">
      <div class="product-card" *ngFor="let item of relatedProducts">

        <div class="discount-tag" *ngIf="item.product_cost">
          -{{ (((item.mrp_price - item.product_cost) / item.mrp_price) * 100) | number:'1.0-0' }}%
        </div>

        <div class="product-image">
          <img [src]="item.product_image" [alt]="item.product_name" loading="lazy">
          <div class="card-actions">
            <button (click)="toggleWishlist(); $event.stopPropagation()" aria-label="Wishlist">
              <i class="bx bx-heart"></i>
            </button>
            <button (click)="openRelatedProduct(item.id); $event.stopPropagation()" aria-label="Quick view">
              <i class="bx bx-search"></i>
            </button>
          </div>
        </div>

        <div class="product-content">
          <div class="stars">
            <i class="bx bxs-star"></i>
            <i class="bx bxs-star"></i>
            <i class="bx bxs-star"></i>
            <i class="bx bxs-star"></i>
            <i class="bx bx-star"></i>
          </div>
          <h4>{{ item.product_name }}</h4>
          <div class="price-wrapper">
            <span class="price">₹{{ item.product_cost }}</span>
            <span class="old-price">₹{{ item.mrp_price }}</span>
          </div>
          <button class="add-cart-btn"
                  (click)="addRelatedToCart(item); $event.stopPropagation()">
            <i class='bx bx-cart'></i> Add to Cart
          </button>
        </div>

      </div>
    </div>

  </div><!-- /related-products -->


  <!-- ═══════════════════════════════
       ZOOM MODAL
  ═══════════════════════════════ -->
  <div class="zoom-modal" *ngIf="showZoomModal" role="dialog" aria-modal="true">
    <div class="zoom-overlay" (click)="closeZoomModal()"></div>
    <div class="zoom-container">

      <button class="zoom-close" (click)="closeZoomModal()" aria-label="Close zoom">
        <i class='bx bx-x'></i>
      </button>

      <div class="zoom-controls">
        <button (click)="zoomOut()" aria-label="Zoom out"><i class='bx bx-minus'></i></button>
        <span>{{ zoomLevel | number:'1.0-1' }}x</span>
        <button (click)="zoomIn()" aria-label="Zoom in"><i class='bx bx-plus'></i></button>
      </div>

      <button class="zoom-nav prev" *ngIf="images.length > 1" (click)="previousImage()" aria-label="Previous">
        <i class='bx bx-chevron-left'></i>
      </button>

      <div class="zoom-image-wrapper" (mousemove)="onZoomMove($event)">
        <img [src]="selectedImage"
             [style.transform]="'scale(' + zoomLevel + ')'"
             [style.transform-origin]="transformOrigin"
             [alt]="product.product_name">
      </div>

      <button class="zoom-nav next" *ngIf="images.length > 1" (click)="nextImage()" aria-label="Next">
        <i class='bx bx-chevron-right'></i>
      </button>

    </div>
  </div>


  <!-- ═══════════════════════════════
       REVIEW READ-MORE MODAL
  ═══════════════════════════════ -->
  <div class="review-modal" *ngIf="showReviewModal" role="dialog" aria-modal="true">
    <div class="review-overlay" (click)="closeReviewModal()"></div>
    <div class="review-popup">

      <button class="close-review" (click)="closeReviewModal()" aria-label="Close review">
        <i class='bx bx-x'></i>
      </button>

      <div class="popup-header">
        <div class="avatar">{{ selectedReview?.customer_name?.charAt(0) }}</div>
        <div>
          <h3>{{ selectedReview?.customer_name }}</h3>
          <div class="stars">
            <i class='bx bxs-star' *ngFor="let star of getStars(selectedReview?.rating)"></i>
          </div>
          <small>{{ selectedReview?.created_date }}</small>
        </div>
      </div>

      <div class="popup-body">{{ selectedReview?.review_comment }}</div>

    </div>
  </div>

</section>